<template>
  <div class="mb-5 p-0 mx-0 d-flex justify-content-center mt-5">
    <!--begin::Nav Tabs-->
    <ul class="dashboard-tabs nav nav-pills nav-primary row-paddingless m-0 p-0 row d-flex justify-content-center my-second-waybill-nav-select-ul"
        role="tablist">
      <li v-for="(value, index) in data" v-if="Number(value.parent_id) === Number(parentId)" @click="modelProxy = value.id" class="nav-item d-flex col-4 flex-grow-1 flex-shrink-0 mb-lg-0">
        <a class="nav-link border py-2 d-flex flex-grow-1 rounded flex-column align-items-center justify-content-center items-center"
           :class="{active: isActive(value.id)}"
           data-toggle="pill">
          <span class="nav-icon w-auto d-flex align-items-center justify-content-center items-center">
          <span
              class="nav-text font-size-lg font-weight-bolder text-center d-inline-block pl-5 text-sm">{{
              $t(value.translations[0].name).toUpperCase()
            }}</span></span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "SecondWaybillNav",
  props: {
    model: {
      default: 1,
    },
    data: {
      default: [],
    },
    parentId: {
      required: false,
    }
  },
  computed: {
    modelProxy: {
      get(){
        return this.model;
      },
      set(value) {
        this.$emit('update:model', value)
      }
    }
  },
  methods: {
    isActive(value) {
      return Number(this.model) === Number(value);
    },
  },
  watch: {
    parentId(value) {
      let item = this.data.find(item => item.parent_id == value)
      this.modelProxy = item.id;
    }
  }
}
</script>

<style scoped>
.svg-icon.svg-icon-2x svg {
  width: 2.5rem !important;
  height: 2.5rem !important;
}

.nav-link {
  padding: 0.5rem 0.5rem !important;
}

.dashboard-tabs li {
  cursor: pointer;
}

.text-xl {
  font-size: 1.1rem !important;
}
</style>


<style lang="scss" scoped>
@import '@/assets/sass/components/_variables.demo.scss';

.svg-icon.svg-icon-2x svg {
  width: 2.5rem !important;
  height: 2.5rem !important;
}

.nav-link {
  padding: 0.5rem 0.5rem !important;
}

.dashboard-tabs li {
  cursor: pointer;
}

.text-xl {
  font-size: 1.3rem !important;
}

.nav.nav-pills.nav-primary .show > .nav-link .nav-icon .svg-icon svg g [fill], .nav.nav-pills.nav-primary .nav-link.active .nav-icon .svg-icon svg g [fill] {
  fill: $primary !important;
}

.nav.nav-pills.nav-primary .nav-link.active {
  color: $primary !important;
  background-color: transparent !important;
}
.nav.nav-pills.nav-primary .nav-link.active .nav-text {
  color: #78cdea !important;
}
.dashboard-tabs {
  .nav-item {
    margin-right: 0;
    .border {
      border-radius: 0 !important;
      border: none !important;
      border-top: 2px solid #78cdea !important;
      border-right: 2px solid #78cdea !important;
      border-bottom: 2px solid #78cdea !important;
    }
    &:last-child .border {
      border-right: none !important;
    }
  }
}
.my-second-waybill-nav-select-ul{
  width: 100%;
}
</style>